import { render } from "./TernakanSmartgene.vue?vue&type=template&id=111d374b&scoped=true"
import script from "./TernakanSmartgene.vue?vue&type=script&lang=js"
export * from "./TernakanSmartgene.vue?vue&type=script&lang=js"

import "./TernakanSmartgene.vue?vue&type=style&index=0&id=111d374b&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111d374b"]])

export default __exports__